module.exports = __webpack_public_path__ + "img/72995dc35c0de986274b0ad228b883e0.72995dc3.png";